import React, { SyntheticEvent, useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'

const delete_red_icon = require('static/delete-red.png')
const upload_icon = require('static/upload-icon.png')

interface IImageUploader {
  onChange: (files: FileList | null) => void
  onDeleteItem: (index: number) => void
  imgList: (string | ArrayBuffer | null)[]
}

export default function ImageUploader(props: IImageUploader) {
  const { onChange, onDeleteItem, imgList } = props

  const handleChooseImg = useCallback(
    (eve: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = eve.target
      onChange(files)
    },
    [onChange]
  )

  const handleDrag = (e: SyntheticEvent) => {
    e.stopPropagation()
    e.preventDefault()
  }
  const handleDragEnter = (e: SyntheticEvent) => {
    e.stopPropagation()
    e.preventDefault()
  }
  const handleDragOver = (e: SyntheticEvent) => {
    e.stopPropagation()
    e.preventDefault()
  }
  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.stopPropagation()
      e.preventDefault()
      const dt = e.dataTransfer
      const { files } = dt

      onChange(files)
    },
    [onChange]
  )
  const handleInputClick = useCallback(
    (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
      const element = event.target as HTMLInputElement
      element.value = ''
    },
    []
  )

  return (
    <div className="image-uploader">
      <p className="hints">
        已上传&nbsp;<span className="count">{imgList.length}</span>
        &nbsp;张，最多上传9张
      </p>

      <div className="image-list">
        {imgList.map((img, index) => (
          <span
            key={`${img} ${index}`}
            style={{ backgroundImage: `url("${img}")` }}
            className="flex-item"
          >
            <img
              src={delete_red_icon}
              onClick={() => onDeleteItem(index)}
              className="delete-red-icon"
            />
          </span>
        ))}
        {imgList.length < 9 && (
          <div className={classNames('upload-area', 'flex-item')}>
            <input
              type="file"
              accept="image/png,image/jpg,image/jpeg"
              multiple
              onChange={handleChooseImg}
              className="add-pic-input"
              onDragStart={handleDrag}
              onDragEnter={handleDragEnter}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onClick={handleInputClick}
            />
          </div>
        )}
      </div>

      <style jsx>
        {`
          .hints {
            margin-top: 4px;
            font-size: 12px;
            line-height: 18px;
            color: #979aa8;
          }
          .count {
            color: #e65800;
          }
          .image-list {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
          }
          .delete-red-icon{
            cursor: pointer;
          }
          .flex-item {
            margin-top: 12px;
            width: 80px;
            height: 80px;
            background-size: cover;
            background-position: center;
            margin-right: 12px;
            position: relative;
          }
          span.flex-item > img{
            object-fit: cover;
            object-position: center;
            width: 14px;
            height: 14px;
            position: absolute;
            right: -4px;
            top: -4px;
          }
          .flex-item:nth-child(-n+3){
            margin-top: 11px;
          }
          .upload-area {
            background-image: url("${upload_icon}");
            background-size: cover;
            background-position: center;
          }

          .upload-area input {
            opacity: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            cursor: pointer;

          }
        `}
      </style>
    </div>
  )
}
